module.exports = __webpack_public_path__ + "img/logo.f5c5c49d.png";